import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useConfirm } from 'material-ui-confirm';

import { ButtonBox } from '../molecules/button-box';
import { trpc } from '../api/trpc';

export const StatsDelete = () => {
  const confirm = useConfirm();

  const deleteStats = trpc.deleteStats.useMutation();

  const handleClick = () => {
    confirm({
      title: (
        <FormattedMessage
          id="stats_delete.confirm.title"
          defaultMessage="Opravdu chcete smazat všechny statistiky?"
        />
      ),
      confirmationText: (
        <FormattedMessage id="stats_delete.confirm" defaultMessage="Smazat" />
      ),
      cancellationText: (
        <FormattedMessage id="stats_delete.cancel" defaultMessage="Zrušit" />
      ),
    })
      .then(() => {
        return deleteStats.mutateAsync();
      })
      .catch(() => {
        // noop
      });
  };

  return (
    <ButtonBox
      title={
        <FormattedMessage
          id="stats_delete.title"
          defaultMessage="Smazat všechny statistiky"
        />
      }
      buttonLabel={
        <FormattedMessage id="stats_delete.button" defaultMessage="Smazat" />
      }
      onClick={handleClick}
      fullWidth
    />
  );
};
